// Single source of truth for treatment note field display.
// Template-driven notes render their own saved fields; legacy notes fall back to these keys.
export const LEGACY_NOTE_FIELDS = [
  ["presenting_complaint", "Presenting complaint"],
  ["history", "Progression / History"],
  ["medical_history", "Medical history"],
  ["medication", "Medication"],
  ["examination", "Assessment"],
  ["treatment", "Treatment"],
  ["advice", "Advice"],
  ["follow_up", "Follow-up / Plan"],
  ["outcome", "Outcome"],
  ["clinician_notes", "Clinician notes"],
];

export const noteDisplayFields = (note) => {
  const sections = note?.template_snapshot?.sections || [];
  const values = note?.field_values || {};
  if (sections.length) {
    const rendered = [...sections]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .filter(sec => {
        const v = values[sec.id];
        return typeof v === "string" ? v.trim() : Boolean(v);
      })
      .map(sec => ({ key: sec.id, label: sec.label, value: values[sec.id] }));
    if (rendered.length) return rendered;
  }
  return LEGACY_NOTE_FIELDS
    .filter(([k]) => note?.[k])
    .map(([k, label]) => ({ key: k, label, value: note[k] }));
};
